import clsx from 'clsx'
import React from 'react'
import { Placement } from 'react-bootstrap/types'
import ElementWithTooltip from '@/components/shared/ElementWithTooltip'

interface Props {
  icon: string,
  tooltip: string
  placement?: Placement
  className?: string
  iconSize?: 'sm' | 'md' | 'lg'
}

export default function IconWithTooltip({
  icon,
  tooltip,
  placement = 'bottom',
  className,
  iconSize = 'md',
}: Props) {
  return (
    <ElementWithTooltip tooltip={tooltip} placement={placement}>
      <i className={clsx(
        `text-primary ${icon} ${className}`,
        iconSize === 'sm' && 'small',
        iconSize === 'md' && 'fs-5',
        iconSize === 'lg' && 'fs-4',
      )} />
    </ElementWithTooltip>
  )
}
